export default "__VITE_ASSET__BDyRnKxm__"